import React from 'react';
import { Popover, Whisper, Table, CellProps, Loader } from 'rsuite';
import { useAppSelector } from '@/config/hooks';
import { useTranslation } from 'react-i18next';

const { Cell } = Table;

const MAX_HEIGHT = 400;

export const NameCell = ({ rowData, dataKey, ...props }: CellProps) => {
  const zonesStore = useAppSelector((state: any) => state.zone?.data);

  const { t } = useTranslation();

  const getZoneName = (zoneId: string) => {
    const zone = zonesStore?.find(
      zone => zone._id === zoneId || (zone._id && zone._id.toString() === zoneId)
    );
    return zone?.name || 'Unknown Zone';
  };

  const getDayName = (day: number) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[day];
  };

  const renderContent = () => {
    if (!rowData?.zonePriorities || rowData?.zonePriorities?.length === 0) {
      return <p>No priorities found</p>;
    }
    return (
      <div
        style={{
          maxHeight: MAX_HEIGHT,
          overflowY: 'auto',
          padding: '8px',
          width: '300px'
        }}
      >
        <div style={{ marginBottom: '8px' }}>
          <strong>Total Priorities: </strong>
          {rowData.zonePriorities?.length}
        </div>
        {rowData?.zonePriorities?.map(priority => (
          <div
            key={priority.id}
            style={{
              padding: '8px',
              borderBottom: '1px solid #e5e5e5',
              backgroundColor: '#f7f7f7',
              borderRadius: '4px',
              marginBottom: '8px'
            }}
          >
            <p style={{ margin: '4px 0' }}>
              <b>{t('Zone:')}</b> {getZoneName(priority?.zone?._id || priority?.zone)}
            </p>
            <p style={{ margin: '4px 0' }}>
              <b>{t('Day:')}</b> {getDayName(priority?.dayOfWeek)}
            </p>
            <p style={{ margin: '4px 0' }}>
              <b>{t('Priority:')}</b> {priority?.priority}
            </p>
          </div>
        ))}
      </div>
    );
  };

  return (
    <Cell {...props}>
      <Whisper
        placement="autoVerticalStart"
        trigger="hover"
        speaker={
          <Popover
            title={
              <div
                style={{
                  padding: '8px',
                  borderBottom: '1px solid #e5e5e5',
                  fontWeight: 'bold'
                }}
              >
                {rowData?.[dataKey] || ''}
              </div>
            }
          >
            {renderContent()}
          </Popover>
        }
        enterable
      >
        <a>{rowData?.[dataKey] || ''}</a>
      </Whisper>
    </Cell>
  );
};
